import { globalState } from '@codeleap/store'
import { APIClient } from '@/services'
import { LocalStorageKeys } from '@/app'

type OnboardingContributeStore = {
  viewCount: number
}

const INITIAL_STATE: OnboardingContributeStore = {
  viewCount: 0,
}

export const onboardingContributeStore = globalState<OnboardingContributeStore>(INITIAL_STATE, {
  persistKey: LocalStorageKeys.CONTRIBUTE_ONBOARDING,
})

export const MAX_ONBOARDING_VIEWS = 6

export function incrementOnboardingView() {
  const current = onboardingContributeStore.get()
  onboardingContributeStore.set({
    ...current,
    viewCount: current.viewCount + 1,
  })
}

export function shouldShowOnboarding(): boolean {
  incrementOnboardingView()
  return canShowOnboarding()
}

export function canShowOnboarding(): boolean {
  const profile = APIClient.Session.QueryKeys.me.getData()

  if (profile?.has_contributed) {
    return false
  }

  const { viewCount } = onboardingContributeStore.get()

  return viewCount < MAX_ONBOARDING_VIEWS
}

export function resetOnboardingStore() {
  onboardingContributeStore.reset(INITIAL_STATE)
}
